import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import isPropValid from '@emotion/is-prop-valid';
export var getStyledFunctionsNames = function getStyledFunctionsNames(fns) {
  return Object.keys(fns);
};
/*
    Takes array of arrays and flattens
    https://stackoverflow.com/a/15030117/11223220
*/

var flatten = function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
};

export var getStyledFunctionsProps = function getStyledFunctionsProps(styledFunctions) {
  return flatten(values(styledFunctions).map(function (fn) {
    return fn.propNames;
  }));
};
export var shouldForwardProp = function shouldForwardProp(prop) {
  var styledFunctions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Allow Attributes for testing to be added to the element
  if (prop === 'data-testid') {
    return true;
  }
  /* 
        If it's one of the styled-system props, don't forward it to the element
        If it's not a s-s prop, but is invalid, don't forward it either.
    */


  return _toConsumableArray(getStyledFunctionsProps(styledFunctions)).indexOf(prop) > -1 ? false : isPropValid(prop);
};
export var values = function values(obj) {
  return Object.keys(obj).map(function (e) {
    return obj[e];
  });
};